import React, { Suspense } from "react";
import PropTypes from "prop-types";
import { Navigate, useLocation } from "react-router-dom";
import { ROUTES } from "../../utils/constants";

const AsyncRoute = ({
  component: Component,
  loggedUserPermissions = [],
  requiredUserPermission,
  ...props
}) => {
  const location = useLocation();

  if (
    requiredUserPermission &&
    !loggedUserPermissions.includes(requiredUserPermission)
  ) {
    return <Navigate to={ROUTES.SIGN_IN} state={{ from: location }} replace />;
  }

  return (
    <Suspense fallback="">
      <Component {...props} />
    </Suspense>
  );
};

AsyncRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  loggedUserPermissions: PropTypes.array,
  requiredUserPermission: PropTypes.string,
};

export default AsyncRoute;
